export const DRAWER_MOBILE_OPEN = 'DRAWER_MOBILE_OPEN';